import { resolveI18n } from "../../services/Translation"

export const TitleWidth = (i18n) => {
  return {
    title: resolveI18n({ i18n, ko: "100px", en: "200px", vi: "240px" }),
  }
}